import { Grid, TextField } from "@mui/material";
import SearchParticipantByName from "../../../../components/inputs/searchParticipantByName/searchParticipantByName";
import Section from "../../../../components/section/section";
import SelectCoachInput from "../../../../components/inputs/coach/selectCoachInput";
import {
  ParticipantData,
  SearchCriteria,
} from "../interface/bookingOverviewInterface";
import React from "react";
import { BookingOverviewContext } from "../context/bookingOverviewContext";
import StartSearchButton from "./startSearchButton";
import RenderFilterCheckboxes from "./renderFilterCheckboxes";

const SearchControlls = (): React.JSX.Element => {
  const {
    searchCriteria,
    setSearchCriteria,
    startSearch,
    participantData,
  }: {
    searchCriteria: SearchCriteria;
    setSearchCriteria: (searchCriteria: SearchCriteria) => void;
    startSearch: () => void;
    participantData: ParticipantData[] | null;
  } = React.useContext(BookingOverviewContext);

  return (
    <Section>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          startSearch();
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SearchParticipantByName
              name={searchCriteria.partipantName}
              onChange={(name) => {
                setSearchCriteria({ ...searchCriteria, partipantName: name });
              }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              color="secondary"
              fullWidth
              type="date"
              value={searchCriteria.date}
              onChange={(e) => {
                setSearchCriteria({ ...searchCriteria, date: e.target.value });
              }}
              id="search-booking-date"
              label="Datum"
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <SelectCoachInput
              coach={searchCriteria.coach}
              setCoach={(coach: { label: string; value: string | null }) => {
                setSearchCriteria({ ...searchCriteria, coach });
              }}
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <StartSearchButton />
          </Grid>

          {participantData !== null && participantData.length > 0 && (
            <RenderFilterCheckboxes />
          )}
        </Grid>
      </form>
    </Section>
  );
};

export default SearchControlls;
